export function HeadersServices(){
  return (
    {
      'idBrand': localStorage.getItem("@brand"),
      'Authorization': localStorage.getItem("@token")
    }
  )
}

